// Filename: uithree.js
// Timestamp: 2018.12.10-09:32:59 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import domwh from 'domwh'

const centerOriginToTopLeft = (THREE, x, y, w, h) => (
  new THREE.Vector2((w / 2) - x, (h / 2) - y))

// convert latitude / longitude to angles between 0 and 2*phi
const latLonToVector3 = (THREE, [ lat, lng ], radius) => {
  const phi = (90 - lat) * Math.PI / 180
  const theta = (180 - lng) * Math.PI / 180

  // Calculate the xyz coordinate from the angles
  return new THREE.Vector3(
    radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta))
}

// linearly convert flat/mapped-image coordinates to angular latitude
// and longitude coordinates, (0,0) coordinate at center of image
const xyToLatLon = (x, y, width, height) => (
  [ 90 - 180 * (y / height),
    360 * (x / width) - 180 ])

const getnormalmaterial = THREE => (
  new THREE.MeshNormalMaterial())

const gettestimgpath = () => (
  './img/equirectangular_test.gif')

const getglrenderer = (THREE, canvaselem) => (
  new THREE.WebGLRenderer({
    preserveDrawingBuffer: true,
    autoClearColor: false,

    canvas: canvaselem,
    alpha: true,
    antialias: true
  }))

// http://mrdoob.com/lab/javascript/threejs/css3d/
const getcssrenderer = (cfg, renderelem) => {
  // const cssRenderer = new THREE.CSS3DRenderer()
  const cssRenderer = window.stuff
  const wharr = domwh(renderelem)

  cssRenderer.setSize(wharr[0], wharr[1])

  if (renderelem && renderelem.hasChildNodes()) {
    while (renderelem.childNodes.length) {
      renderelem.removeChild(renderelem.firstChild)
    }
  }

  renderelem.appendChild(cssRenderer.domElement)

  return cssRenderer
}

// let renderereffect;
//
// cfg.isvrmodesupport = false;
//
// if (cfg.isvrmodesupport && cfg.iswebgl) {
//   renderereffect = o.getvreffect(node, renderer);
// } else {
//   renderereffect = renderer;
//   // console.log('[!!!] vrmode not supported');
// }
//
// return renderereffect;

// o.getvideotexture = videoelem => {
//   const videotexture = new THREE.VideoTexture(videoelem);
//
//   videotexture.format = THREE.RGBFormat;
//   videotexture.minFilter = THREE.LinearFilter;
//   videotexture.magFilter = THREE.LinearFilter;
//
//   return videotexture;
// };
const getscaledfov = (fov = 64, h, newh) => {
  const tanFOV = Math.tan(((Math.PI / 180) * fov / 2))

  return (360 / Math.PI) * Math.atan(tanFOV * (newh / h))
}

const getperspectivecamera = (THREE, elem, fov = 64, clippingdist = 1000) => {
  const canvelem = elem
  const canvelemwh = domwh(canvelem)
  const aspect = canvelemwh[0] / canvelemwh[1]

  fov = getscaledfov(64, 400, canvelemwh[1])

  return new THREE.PerspectiveCamera(fov, aspect, 1, clippingdist)
}

// o.getvideomaterial = videotexture => (
//   new THREE.MeshBasicMaterial({
//     map: videotexture,
//     side: THREE.FrontSide
//   }));

const getyawobj = (THREE, camera) => {
  const bodygroup = new THREE.Object3D()
  const headgroup = new THREE.Object3D()

  bodygroup.name = 'bodygroup'
  headgroup.name = 'headgroup'
  camera.name = 'camera'

  bodygroup.add(headgroup)
  headgroup.add(camera)

  return [ bodygroup, headgroup ]
}

// https://github.com/mrdoob/three.js/issues/1239
const getcamdisth = (elem, cam, dist) => (
  Math.tan((cam.fov / 2)) * dist)

const getcamdistwh = (elem, cam, dist) => {
  const wh = domwh(elem)
  const aspect = wh[0] / wh[1]
  const vFOV = getcamdisth(elem, cam, dist)
  const hFOV = Math.atan(Math.tan(vFOV) * aspect)
  const width = 2 * Math.tan((hFOV)) * dist

  return [ width, vFOV ]
}

const glrender = ({ glrenderer, glscene, camera }) => glrenderer
  && glrenderer.render(glscene, camera)

const cssrender = ({ cssrenderer, cssscene, camera }) => cssrenderer
  && cssrenderer.render(cssscene, camera)

const render = renderobj => (
  glrender(renderobj),
  cssrender(renderobj))

// http://stackoverflow.com/questions/33152132
//   /three-js-collada-whats-the-proper-way-to-dispose-and-release-memory-garbag
const disposeNode = (THREE, parentObject) => {
  if (!parentObject)
    return null

  const materialdispose = material => {
    if (!material)
      return

    if (material.map) material.map.dispose()
    if (material.lightMap) material.lightMap.dispose()
    if (material.bumpMap) material.bumpMap.dispose()
    if (material.normalMap) material.normalMap.dispose()
    if (material.specularMap) material.specularMap.dispose()
    if (material.envMap) material.envMap.dispose()

    material.dispose() // disposes any programs associated with the material
  }

  parentObject.traverse(node => {
    if (node instanceof THREE.Mesh) {
      if (node.geometry) {
        node.geometry.dispose()
      }

      materialdispose(node.material)
    }
  })

  for (let i = parentObject.children.length - 1; i >= 0; i--) {
    parentObject.remove(parentObject.children[i])
  }
}

// vertically-shift what is rendered by camera
const rendererResizeWH = (THREE, renderer, wharr, camera, offset) => {
  const desiredWidth = wharr[0]
  const desiredHeight = wharr[1]
  const size = renderer.getSize(new THREE.Vector2())

  renderer.setSize(desiredWidth, desiredHeight, false)
  camera.setViewOffset(
    size.x, size.y, 0, offset, desiredWidth, desiredHeight)
}

export {
  centerOriginToTopLeft,
  latLonToVector3,
  xyToLatLon,
  rendererResizeWH,
  getnormalmaterial,
  gettestimgpath,
  getglrenderer,
  getcssrenderer,
  getperspectivecamera,
  getyawobj,
  getcamdisth,
  getcamdistwh,
  glrender,
  cssrender,
  render,
  disposeNode
}
